import { z } from 'zod'
import type { PaginatedResponse } from './common'

export const liveSessionStatusSchema = z.enum(['scheduled', 'cancelled'])
export type LiveSessionStatus = z.infer<typeof liveSessionStatusSchema>

export const createLiveSessionSchema = z.object({
  title_en: z.string().min(3).max(200),
  title_hi: z.string().min(3).max(200),
  description_en: z.string().max(2000).optional(),
  description_hi: z.string().max(2000).optional(),
  start_datetime: z.string().datetime(),
  join_url: z.string().url(),
  status: liveSessionStatusSchema.default('scheduled'),
})

export const updateLiveSessionSchema = createLiveSessionSchema.partial()

export type CreateLiveSessionInput = z.infer<typeof createLiveSessionSchema>
export type UpdateLiveSessionInput = z.infer<typeof updateLiveSessionSchema>

export type LiveSessionResponse = {
  id: string
  title_en: string
  title_hi: string
  description_en?: string | null
  description_hi?: string | null
  start_datetime: string
  join_url: string
  status: LiveSessionStatus
  created_at: string
  updated_at: string
}

export type PublicLiveSessionResponse = {
  id: string
  title: string
  description?: string | null
  start_datetime: string
  join_url: string
  status: LiveSessionStatus
}

export type LiveSessionSortBy =
  | 'start_datetime'
  | 'created_at'
  | 'title_en'
  | 'title_hi'

export type PaginatedLiveSessionResponse =
  PaginatedResponse<LiveSessionResponse>
export type PaginatedPublicLiveSessionResponse =
  PaginatedResponse<PublicLiveSessionResponse>
